import Slides from '@/components/slides/index.vue';
import { mapGetters } from 'vuex';
import Service from '../e-commerce.service';
import { getQRCode } from '@/utils/common.js';
export default {
  components: {
    Slides
  },
  data () {
    return {
      detail: {},
      showDialog: false,
      buyCount: 1,
      slides: [],
      showPhone: false,
      tuoguanList: [],
      nongjiList: []
    };
  },
  computed: {
    ...mapGetters([
      'isSignin',
      'userInfo'
    ])
  },

  // watch: {
  //   slides (newValue) {
  //     if (newValue) {
  //       this.$nextTick(() => {
  //         this.galleryThumbsLunbo();
  //         this.galleryTopLunbo();
  //       });
  //     }
  //   }
  // },

  created () {
    this.getDetail();
  },
  methods: {
    getQRCode,
    getDetail () {
      Service.getProductDetail(this.$route.query.id).then(res => {
        this.detail = res.data;
        this.slides = res.data.logos.map(item => item.ossImgUrl);
      });
    },
    goBack () {
      this.$router.back();
    }
  }
};
